export enum ContractSignatureType {
  TESTEMUNHA = 'TESTEMUNHA',
  INTERVENIENTE = 'INTERVENIENTE',
  EMISSOR = 'EMISSOR',
  CONTRATANTE = 'CONTRATANTE',
  CONTRATADA = 'CONTRATADA',
  FIADOR = 'FIADOR',
  PARCEIRO = 'PARCEIRO',
  CONSULTOR = 'CONSULTOR',
  REPRESENTANTE = 'REPRESENTANTE',
  CONTADOR = 'CONTADOR',
  UNIDADE = 'UNIDADE',
  PARCEIRA_REPRESENTADA = 'Parceira Representada',
  PARCEIRO_REPRESENTANTE = 'Parceiro Representante',
  REPRESENTANTE_COMERCIAL = 'Representante Comercial',
  PARCERIA_CONSULTORA = 'Parceria Consultora',
  
}
